import { useAuth } from "@/context/AuthContext";

// Shows a small "affiliate links" disclosure near exports — only when an
// affiliate link is configured on the backend (env-driven).
export function AffiliateDisclosure({ className = "" }) {
  const { user } = useAuth();
  if (!user?.affiliate_enabled) return null;
  return (
    <p data-testid="affiliate-disclosure" className={`text-xs italic text-muted-foreground ${className}`}>
      This content may contain affiliate links.
    </p>
  );
}
